import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSubscriptions } from '@/store/subscription/subscription.actions';
import {
  isSubscriptionOnTrialFactory,
  isSubscriptionInactiveFactory,
  isSubscriptionActiveFactory,
} from '@/store/subscription/subscription.selectors';

/**
 * Sets subscriptions.
 */
export const useSetSubscriptions = () => {
  const dispatch = useDispatch();

  return useCallback(
    (subscriptions: any) => {
      dispatch(setSubscriptions(subscriptions));
    },
    [dispatch],
  );
};

/**
 * The organization subscription selector.
 * @param   {string} slug
 * @returns {}
 */
export const useSubscription = (slug = 'main') => {
  const isSubscriptionOnTrial = useSelector(
    isSubscriptionOnTrialFactory(slug) as unknown as (state: any) => boolean,
  );
  const isSubscriptionInactive = useSelector(
    isSubscriptionInactiveFactory(slug) as unknown as (state: any) => boolean,
  );
  const isSubscriptionActive = useSelector(
    isSubscriptionActiveFactory(slug) as unknown as (state: any) => boolean,
  );

  return {
    isSubscriptionActive,
    isSubscriptionInactive,
    isSubscriptionOnTrial,
  };
};
